import { WidgetType } from './GlobalWidget'

export enum Action {
  ACTIVATE_GLOBAL_FILTER_ALL = 'ACTIVATE_GLOBAL_FILTER_ALL',
  ACTIVATE_GLOBAL_FILTER_CUSTOM = 'ACTIVATE_GLOBAL_FILTER_CUSTOM',
  ACTIVATE_GLOBAL_FILTER_STANDARD = 'ACTIVATE_GLOBAL_FILTER_STANDARD',
  AI_CHAT_ANSWER_COPIED = 'AI_CHAT_ANSWER_COPIED',
  AI_CHAT_ASKED_AGAIN = 'AI_CHAT_ASKED_AGAIN',
  AI_CHAT_HISTORY_CHAT_CONTINUED = 'AI_CHAT_HISTORY_CHAT_CONTINUED',
  AI_CHAT_HISTORY_CHAT_OPENED = 'AI_CHAT_HISTORY_CHAT_OPENED',
  AI_CHAT_HISTORY_OPENED = 'AI_CHAT_HISTORY_OPENED',
  AI_CHAT_SUGGESTION_CLICKED = 'AI_CHAT_SUGGESTION_CLICKED',
  AI_CHAT_STREAM_INTERRUPTED = 'AI_CHAT_STREAM_INTERRUPTED',
  COLUMNS_IN_SHOW_POSTS_EDITED = 'COLUMNS_IN_SHOW_POSTS_EDITED',
  CUSTOMIZED_SEGMENT_BY_CHANGED = 'CUSTOMIZED_SEGMENT_BY_CHANGED',
  CUSTOMIZED_SEGMENT_BY_CLEARED = 'CUSTOMIZED_SEGMENT_BY_CLEARED',
  DASHBOARD_CREATED = 'DASHBOARD_CREATED',
  DASHBOARD_DELETED = 'DASHBOARD_DELETED',
  DASHBOARD_EDITED = 'DASHBOARD_EDITED',
  DASHBOARD_EXAMPLE_OPENED = 'DASHBOARD_EXAMPLE_OPENED',
  DASHBOARD_IMAGE_EXPORTED = 'DASHBOARD_IMAGE_EXPORTED',
  DASHBOARD_OPENED = 'DASHBOARD_OPENED',
  DASHBOARD_PUBLISHED = 'DASHBOARD_PUBLISHED',
  DASHBOARD_RESETTED = 'DASHBOARD_RESETTED',
  DASHBOARD_UNPUBLISHED = 'DASHBOARD_UNPUBLISHED',
  ENTITY_OPENED = 'ENTITY_OPENED',
  EXTENSIVE_KPI_INFORMATION_SHOWNED = 'EXTENSIVE_KPI_INFORMATION_SHOWNED',
  GLOBAL_SEARCH_CLOSED = 'GLOBAL_SEARCH_CLOSED',
  GLOBAL_SEARCH_NAVIGATED = 'GLOBAL_SEARCH_NAVIGATED',
  GLOBAL_SEARCH_OPENED = 'GLOBAL_SEARCH_OPENED',
  // Renamed together with the stored values in HP-1018.
  INSIGHTS_OPENED = 'INSIGHTS_OPENED',
  INSIGHT_OPENED = 'INSIGHT_OPENED',
  INVITE_ACCEPTED_TO_HOMEPAL = 'INVITE_ACCEPTED_TO_HOMEPAL',
  INVITE_SENT_TO_DASHBOARD = 'INVITE_SENT_TO_DASHBOARD',
  INVITE_SENT_TO_HOMEPAL = 'INVITE_SENT_TO_HOMEPAL',
  KPI_INFORMATION_SHOWNED = 'KPI_INFORMATION_SHOWNED',
  KPI_OPTION_SLICE_CREATED = 'KPI_OPTION_SLICE_CREATED',
  KPI_OPTION_SLICE_EDITED = 'KPI_OPTION_SLICE_EDITED',
  LIST_SORTED = 'LIST_SORTED',
  MARKED_DASHBOARD_AS_FAVORITE = 'MARKED_DASHBOARD_AS_FAVORITE',
  MARKED_REPORT_AS_FAVORITE = 'MARKED_REPORT_AS_FAVORITE',
  METRIC_OPENED = 'METRIC_OPENED',
  METRIC_SETTINGS_EDITED = 'METRIC_SETTINGS_OPENED',
  METRIC_SETTINGS_OPENED = 'METRIC_SETTINGS_OPENED',
  MY_REAL_ESTATES_SAVED = 'MY_REAL_ESTATES_SAVED',
  NAVIGATED_TO_SOURCE = 'NAVIGATED_TO_SOURCE',
  REMOVED_DASHBOARD_AS_FAVORITE = 'REMOVED_DASHBOARD_AS_FAVORITE',
  REMOVED_REPORT_AS_FAVORITE = 'REMOVED_REPORT_AS_FAVORITE',
  REPORT_OPENED = 'REPORT_OPENED',
  REPORT_PUBLISHED = 'REPORT_PUBLISHED',
  REPORT_UNPUBLISHED = 'REPORT_UNPUBLISHED',
  SAVED_DASHBOARD_FILTER_CREATED = 'SAVED_DASHBOARD_FILTER_CREATED',
  SAVED_DASHBOARD_FILTER_DELETED = 'SAVED_DASHBOARD_FILTER_DELETED',
  SAVED_DASHBOARD_FILTER_EDITED = 'SAVED_DASHBOARD_FILTER_EDITED',
  SELECTION_FILTERED = 'SELECTION_FILTERED',
  SELECTION_RESETTED = 'SELECTION_RESETTED',
  SHOW_POSTS = 'SHOW_POSTS',
  SHOW_POSTS_COLUMN_SEARCHED = 'SHOW_POSTS_COLUMN_SEARCHED',
  SHOW_POSTS_EXPORTED = 'SHOW_POSTS_EXPORTED',
  SHOW_POSTS_FILTERED = 'SHOW_POSTS_FILTERED',
  SHOW_POSTS_FILTER_REMOVED = 'SHOW_POSTS_FILTER_REMOVED',
  SHOW_POSTS_SORTED = 'SHOW_POSTS_SORTED',
  SHOW_POSTS_VIEW_CHANGED = 'SHOW_POSTS_VIEW_CHANGED',
  SHOW_POSTS_VIEW_SWITCHED = 'SHOW_POSTS_VIEW_SWITCHED',
  SLICE_CREATED = 'SLICE_CREATED',
  SLICE_DELETED = 'SLICE_DELETED',
  SLICE_EDITED = 'SLICE_EDITED',
  TIME_PERIOD_FILTERED = 'TIME_PERIOD_FILTERED',
  TIME_PERIOD_RESETTED = 'TIME_PERIOD_RESETTED',
  WIDGET_CREATED = 'WIDGET_CREATED',
  WIDGET_DATA_EXPORTED = 'WIDGET_DATA_EXPORTED',
  WIDGET_DELETED = 'WIDGET_DELETED',
  WIDGET_EDITED = 'WIDGET_EDITED',
  WIDGET_ENLARGED = 'WIDGET_ENLARGED'
}

export enum Context {
  DUPLICATE = 'DUPLICATE',
  FROM_GLOBAL_SEARCH = 'FROM_GLOBAL_SEARCH',
  FROM_GROUP = 'FROM_GROUP',
  FROM_GROUP_RESOURCES = 'FROM_GROUP_RESOURCES',
  FROM_GROUP_RESOURCES_PREVIEW = 'FROM_GROUP_RESOURCES_PREVIEW',
  FROM_HOME_FAVORITES = 'FROM_HOME_FAVORITES',
  FROM_HOME_GROUP_PREVIEW = 'FROM_HOME_GROUP_PREVIEW',
  FROM_HOME_RECENT = 'FROM_HOME_RECENT',
  FROM_SCRATCH = 'FROM_SCRATCH',
  FROM_EXPLORE = 'FROM_EXPLORE',
  FROM_LANDING_PAGE = 'FROM_LANDING_PAGE',
  FROM_FAVORITES = 'FROM_FAVORITES',
  FROM_FOLDER = 'FROM_FOLDER',
  FROM_DRAFTS = 'FROM_DRAFTS',
  FROM_NAVBAR = 'FROM_NAVBAR',
  NAVIGATE_TO_NEW_TAB = 'NAVIGATE_TO_NEW_TAB',
  FROM_SEARCH = 'FROM_SEARCH',
  FROM_WIDGET = 'FROM_WIDGET',
  FROM_WIDGET_SETTINGS = 'FROM_WIDGET_SETTINGS',
  FROM_FILTER_MENU = 'FROM_FILTER_MENU',
  FROM_SAVED_DASHBOARD_FILTER = 'FROM_SAVED_DASHBOARD_FILTER',
  FROM_SUGGESTIONS = 'FROM_SUGGESTIONS',
  FROM_CHAT = 'FROM_CHAT',
  FROM_CHAT_START = 'FROM_CHAT_START',
  CHAT_CONTINUABLE = 'CHAT_CONTINUABLE',
  CHAT_READ_ONLY = 'CHAT_READ_ONLY',
  FROM_SHOW_POSTS = 'FROM_SHOW_POSTS',
  // Renamed together with the stored values in HP-1018.
  FROM_INSIGHT = 'FROM_INSIGHT',
  FROM_ENTITIES = 'FROM_ENTITIES',
  FROM_ENTITY = 'FROM_ENTITY',
  FROM_COLUMNS = 'FROM_COLUMNS',
  FROM_METRIC = 'FROM_METRIC',
  FROM_METRICS = 'FROM_METRICS',
  FROM_METRIC_PREVIEW = 'FROM_METRIC_PREVIEW',
  FROM_METRIC_PREVIEW_DIALOG = 'FROM_METRIC_PREVIEW_DIALOG',
  MOVE = 'MOVE',
  SHARE_LINK = 'SHARE_LINK',
  NOTIFICATION = 'NOTIFICATION',
  // SAVED_DASHBOARD_FILTER_EDITED
  TITLE = 'TITLE',
  CONDITIONS = 'CONDITIONS',
  // base paths of pages
  FROM_HOME_PAGE = 'FROM_HOME_PAGE',
  FROM_SETTINGS_PAGE = 'FROM_SETTINGS_PAGE',
  FROM_GROUP_PAGE = 'FROM_GROUP_PAGE',
  FROM_GROUPS_PAGE = 'FROM_GROUPS_PAGE',
  FROM_DASHBOARD_PAGE = 'FROM_DASHBOARD_PAGE',
  FROM_DASHBOARDS_PAGE = 'FROM_DASHBOARDS_PAGE',
  FROM_DASHBOARD_FAVORITES_PAGE = 'FROM_DASHBOARD_FAVORITES_PAGE',
  FROM_DASHBOARD_DRAFTS_PAGE = 'FROM_DASHBOARD_DRAFTS_PAGE',
  FROM_EXPLORE_PAGE = 'FROM_EXPLORE_PAGE',
  FROM_KEY_METRICS_PAGE = 'FROM_KEY_METRICS_PAGE',
  FROM_KEY_METRICS_RESOURCES = 'FROM_KEY_METRICS_RESOURCES',
  FROM_METRIC_PAGE = 'FROM_METRIC_PAGE',
  FROM_METRICS_PAGE = 'FROM_METRICS_PAGE',
  FROM_ENTITY_PAGE = 'FROM_ENTITY_PAGE',
  FROM_ENTITIES_PAGE = 'FROM_ENTITIES_PAGE',
  FROM_REPORT_PAGE = 'FROM_REPORT_PAGE',
  FROM_REPORT_EDITIONS_PAGE = 'FROM_REPORT_EDITIONS_PAGE',
  FROM_REPORTS_PAGE = 'FROM_REPORTS_PAGE'
}

export enum ENavDestination {
  PAGE_HOME = 'PAGE_HOME',
  PAGE_KEY_METRIC = 'PAGE_KEY_METRIC',
  PAGE_KEY_METRICS = 'PAGE_KEY_METRICS',
  PAGE_TASKS = 'PAGE_TASKS',
  PAGE_GROUP = 'PAGE_GROUP',
  PAGE_GROUPS = 'PAGE_GROUPS',
  PAGE_DASHBOARD = 'PAGE_DASHBOARD',
  PAGE_DASHBOARDS = 'PAGE_DASHBOARDS',
  PAGE_FAVORITES = 'PAGE_FAVORITES',
  PAGE_TEMPLATES = 'PAGE_TEMPLATES',
  PAGE_METRIC = 'PAGE_METRIC',
  PAGE_METRICS = 'PAGE_METRICS',
  PAGE_ENTITY = 'PAGE_ENTITY',
  PAGE_ENTITIES = 'PAGE_ENTITIES'
}

export interface UserEventBody {
  action: Action
  context: Context | WidgetType | null
  dashboard_group_id?: string | null
  dashboard_id?: string | null
  input?: string | null
  analysis_id?: string | null
  report_id?: string | null
  type?: ENavDestination | null
}
